module.exports = __webpack_public_path__ + "img/btn_destination_map.c42c69ac.png";